export const SITE_SETTINGS = {
  NAME: "Invyntra",
  HOME_URL: "https://www.invyntra.in/",
  PRIVACY_URL: "https://www.invyntra.in/privacy",
  CONTACT_URL: "https://www.invyntra.in/contact",
  ADDRESS: "Coming soon...",
  CONTACT_EMAIL: "contact@invyntra.in",
  CONTACT_NUMBER: "+91 9353231534",
};

export const LOCAL_STORAGE = {
  AUTH_TOKEN: "auth_token",
  CLIENT_SOURCE: "client_source",
  MODE: "mode",
  USER_INFO: "user_info",
  QUERY_PARAMS: "query_params",
  THEME_COLORS: "theme_colors",
};

export const constants = {
  ERROR_MESSAGES: {
    SOMETHING_WENT_WRONG: "Something went wrong!",
  },
  SEARCH_FOOD_ITEM_TITLE: {
    SEARCH_RESULT: "Search Result",
    RECENT_SEARCH: "Recent Search",
  },
};

export const paymentModes = ["card", "upi", "netbanking", "manual", "free"];
export const paymentStatus = ["pending", "success", "failed"];

export const transactionTypes = ["payment", "refund"];
export const transactionStatuses = [
  "created",
  "processing",
  "success",
  "failed",
];

export const genderOptions = [
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
];
